"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated consider removing this class, it only has static methods
 */
class DirectPanel {
    addAndReplaceElement(widget, toReplace) {
        let parent = toReplace.parentElement;
        parent.replaceChild(widget.element, toReplace);
    }
    addWrapper(widget) {
        // Intentionally left empty
    }
}
exports.default = DirectPanel;
//# sourceMappingURL=DirectPanel.js.map